import { TeamsFxContext } from "@/Context";
import "@/index.css";
import {
  FluentProvider,
  teamsDarkTheme,
  teamsHighContrastTheme,
  teamsLightTheme,
  tokens,
} from "@fluentui/react-components";
import { createRoot } from "react-dom/client";
import { BrowserRouter, createRoutesFromElements, Route, useRoutes } from "react-router-dom";
import { LoadingScreen } from "./components/common/LoadingScreen";
import { ErrorDialogProvider } from "./components/error/ErrorDialogContext";
import useAuth from "./hooks/useAuth";
import { ChatPage } from "./pages/ChatPage";
import { ServiceSelectionPage } from "./pages/ServiceSelectionPage";
import { DefaultLayout } from "./pages/layout/DefaultLayout";

const AppRoutes = () => {
  const routes = createRoutesFromElements(
    <Route path="/" element={<DefaultLayout />}>
      <Route index element={<ServiceSelectionPage />} />
      <Route path="threads/:threadId" element={<ChatPage />} />
    </Route>,
  );

  return useRoutes(routes);
};
function App() {
  const { themeString, userName, token, authCompleted } = useAuth();
  return (
    authCompleted
      ? (
        <TeamsFxContext.Provider value={{ themeString, userName, token }}>
          <FluentProvider
            theme={themeString === "dark"
              ? teamsDarkTheme
              : themeString === "contrast"
              ? teamsHighContrastTheme
              : {
                ...teamsLightTheme,
                colorNeutralBackground3: "#eeeeee",
              }}
            style={{ background: tokens.colorNeutralBackground3 }}
          >
            <ErrorDialogProvider>
              <BrowserRouter>
                <AppRoutes />
              </BrowserRouter>
            </ErrorDialogProvider>
          </FluentProvider>
        </TeamsFxContext.Provider>
      )
      : <LoadingScreen message="認証中..." />
  );
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
